"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popoverMaxWidthVariant = exports.popoverMinWidthVariant = exports.popoverTheme = void 0;
const component_theme_1 = require("@clds/component-theme");
exports.popoverTheme = (0, component_theme_1.createTheme)({
    borderColor: component_theme_1.globalTheme.palette.errorAlt,
    byMaxWidth: {
        sm: { maxWidth: '100px' },
        md: { maxWidth: '300px' },
        lg: { maxWidth: '400px' },
        xl: { maxWidth: '600px' },
        none: { maxWidth: 'none' },
    },
    byMinWidth: {
        sm: { minWidth: '100px' },
        md: { minWidth: '200px' },
        lg: { minWidth: '300px' },
        xl: { minWidth: '500px' },
        none: { minWidth: 'none' },
    },
    transition: {
        duration: '200ms',
    },
}, 'popover');
exports.popoverMinWidthVariant = (0, component_theme_1.createVariant)(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => exports.popoverTheme.byMinWidth[props.minWidth || 'none']);
exports.popoverMaxWidthVariant = (0, component_theme_1.createVariant)(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => exports.popoverTheme.byMaxWidth[props.maxWidth || 'none']);
//# sourceMappingURL=theme.js.map